var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel_sale"},[(_vm.type==='list')?_c('div',{staticClass:"list"},[_c('jihuaList')],1):_vm._e(),(_vm.type==='add')?_c('div',{staticClass:"add"},[_vm._v(" 计划详情 ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }